import styled from 'styled-components';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  /* background: ${(props) => props.theme.colors.neutral100}; */
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  border-radius: 15px;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

export const MostPopular = styled.div`
  padding: 5px 20px;
  background-color: ${({ theme }) => theme.colors.primary900};
  border-radius: 100px;
  display: inline-flex;
`;
